import React from 'react';
import { RadioButton } from 'primereact/radiobutton';

const RadioButtonBDI = props => {
    return React.createElement(
        'div',
        { className: 'p-field-radiobutton' },
        React.createElement(RadioButton, {
            inputId: props.inputId,
            name: props.name,
            value: props.valor,
            checked: props.checked,
            onChange: props.acao,
            disabled: props.disabled
        }),
        React.createElement(
            'label',
            { htmlFor: props.inputId },
            props.label
        )
    );
};

export default RadioButtonBDI;